import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fullName',
  pure: true,
  standalone: true,
})
export class FullNamePipe implements PipeTransform {
  public transform({ firstName, lastName, middleName }: { firstName: string; middleName?: string; lastName: string }): string {
    return middleName ? `${firstName} ${middleName} ${lastName}` : `${firstName} ${lastName}`;
  }
}
